<script setup lang="ts">
import { Image } from '@unpic/vue'
import { config } from '@/lib/helpers/config.helpers'
import type { ProcessableImageType } from '@/ui-library/types/image.types'

const props = withDefaults(
  defineProps<{
    image: ProcessableImageType
    width: number
    height: number
    alt: string
    layout?: 'constrained' | 'fullWidth' | 'fixed'
    quality?: number
    skipWidth?: boolean
    skipHeight?: boolean
    objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
    resizeType?: 'fill' | 'fit' | 'fill-down' | 'force' | 'auto'
  }>(),
  { layout: 'constrained', quality: 90, resizeType: 'fill', objectFit: 'cover' },
)

const imageUrlTransformer = ({ width = 0, height = 0 }) => {
  return `${config.mediaApiUrl}/_/rs:${props.resizeType}:${props.skipWidth ? 0 : width}:${props.skipHeight ? 0 : height}/g:sm/q:${props.quality}/${props.image.key}`
}
</script>

<template>
  <Image
    v-if="image?.key"
    :layout="layout"
    :width="width"
    :height="height"
    :transformer="imageUrlTransformer"
    :src="image.key"
    :object-fit="objectFit"
    :alt="alt"
  />
  <img v-else-if="image?.url" :src="image.url" :width="width" :height="height" :alt="alt" />
</template>
